// src/components/bar/OrderFooter.js
import React, { useEffect, useState } from 'react';
import styles from './Bar.module.css';

const OrderFooter = ({ orderingProduct, orderId, orderStatus, onFooterClick, onPickup }) => {
  // 状態変更を検知するための状態
  const [currentStatus, setCurrentStatus] = useState(orderStatus);

  // orderStatusが変更されたら反映する
  useEffect(() => {
    console.log('OrderFooter: 注文ステータスが更新されました:', orderStatus);
    setCurrentStatus(orderStatus);
  }, [orderStatus]);

  if (!orderingProduct) return null;

  // 注文ステータスに応じた表示（注文中 / 作り始めました / 受け取る）
  const getActionButton = () => {
    if (currentStatus === 'ready') {
      return (
        <button 
          onClick={(e) => {
            e.stopPropagation();
            onPickup();
          }}
          className={`${styles.pickupButton} ${styles.pickupButtonHighlight}`}
        >
          受け取る
        </button>
      );
    }
    if (currentStatus === 'preparation') {
      return (
        <div className={styles.processingButton}>
          作り始めました
        </div>
      );
    }
    return (
      <div className={styles.processingButton}>
        注文中
      </div>
    );
  };

  const isReadyForPickup = currentStatus === 'ready';

  return (
    <div 
      className={`${styles.footer} ${isReadyForPickup ? styles.footerHighlight : ''}`}
      onClick={onFooterClick}
    >
      <div className={styles.footerContainer}>
        <div className={styles.productImage}>
          <img 
            src={orderingProduct.image || "/api/placeholder/100/100"} 
            alt={orderingProduct.name}
            className={styles.productImageInner}
          />
        </div>
        <div className={styles.productInfo}>
          <p className={styles.productName}>{orderingProduct.name}</p>
          <p className={styles.productPrice}>
            ¥{orderingProduct.price}
          </p>
          {orderId && (
            <p className={styles.productOrderId}>
              注文ID: {orderId.substring(0, 8)}
            </p>
          )}
        </div>
        <div className={styles.actionButton}>
          {getActionButton()}
        </div>
      </div>
    </div>
  );
};

export default OrderFooter;